import client from '@/api'
import axios from 'axios'

export default {
    login(username: string, password: string): Promise<account.TCurrent> {
        return client.post({
            url: '/common/auth/api/login',
            data: { userName: username, password },
        })
    },

    loginex(username: string): Promise<account.TCurrent> {
        return client.post({
            url: '/common/auth/api/loginex',
            data: { username },
        })
    },

    loginHint(loginHint: string): Promise<account.TCurrent> {
        return client.post({
            url: '/common/auth/api/loginHint',
            data: { username: loginHint },
        })
    },

    loginAssertion(username: string, userAssertion: string): Promise<account.TCurrent> {
        return client.post({
            url: '/Graph/Sso/api/LoginAssertion',
            data: { username: username, assertion: userAssertion }
        })
    },

    logout(): Promise<void> {
        // logout은 api의 ResponseWrapper에 의해 정제된 데이터가 아니므로 HTTP 사용
        return client.get({ url: '/common/auth/api/logout' })
    },

    adfsLogout(): Promise<account.AdfsLogoutResponse> {
        return axios.get('/cm/common/Adfs/api/logout').then(res => {
            return res.data as account.AdfsLogoutResponse;
        });
    },
}
